import React from 'react'

interface ModalProps {
    children?: React.ReactNode;
    showModal: boolean;
    classname?: string;
    style?: any;
}

export const Modal = ({ showModal, children, classname, style }: ModalProps) => {
    return (
        <div>
            {showModal && <div className={`modal border-rounded ${showModal ? 'show' : ''} d-flex justify-content-center align-items-center m-auto`} tabIndex={-1} role="dialog" style={{ display: showModal ? 'block' : 'none' }}>
                <div className={`modal-dialog modal-dialog-centered m-auto ${classname}`} style={style}>
                    <div className={`modal-content w-100 h-100`}>
                        <div className="modal-body modal-content w-100 h-100 d-flex flex-column justify-content-center m-0 p-0">
                            {children}
                        </div>
                    </div>
                </div>
            </div>}
            {showModal && <div className="modal-backdrop fade show"></div>}
        </div>
    )
}


